var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 4.89653C12.0536 4.68567 12.0536 4.33425 11.8392 4.09996L7.83722 0.163998C7.45608 -0.187427 6.86055 0.0702851 6.86055 0.56228V2.8114H3.62084C3.28734 2.8114 3.04913 3.06911 3.04913 3.37368V5.6228C3.04913 5.9508 3.28734 6.18509 3.62084 6.18509H6.86055V8.43421C6.86055 8.94963 7.4799 9.18391 7.83722 8.83249L11.8392 4.89653ZM4.5737 8.71535V7.77821C4.5737 7.63764 4.43077 7.49707 4.28784 7.49707H2.28685C1.85806 7.49707 1.52457 7.16908 1.52457 6.74737V2.24912C1.52457 1.85084 1.85806 1.49941 2.28685 1.49941H4.28784C4.43077 1.49941 4.5737 1.38227 4.5737 1.21827V0.28114C4.5737 0.14057 4.43077 0 4.28784 0H2.28685C1.02432 0 0 1.00742 0 2.24912V6.74737C0 7.98907 1.02432 8.99649 2.28685 8.99649H4.28784C4.43077 8.99649 4.5737 8.87935 4.5737 8.71535Z",
    fill: "#474747"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/logOut.d87c78e7.svg";
export { ForwardRef as ReactComponent };